import { render, staticRenderFns } from "./xProfitLogoComponent.vue?vue&type=template&id=4a92c062&scoped=true&lang=pug"
import script from "./xProfitLogoComponent.vue?vue&type=script&lang=js"
export * from "./xProfitLogoComponent.vue?vue&type=script&lang=js"
import style0 from "./xProfitLogoComponent.vue?vue&type=style&index=0&id=4a92c062&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a92c062",
  null
  
)

export default component.exports